import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { ServiceSearchItem, ServiceSuggestionClickHandler } from '../../../model';
import { SEARCH_TEST_ID } from '../../../test/test-ids';
import { getFullUrl } from '../../../utils/paths';
import { ServiceCard } from '../../ServiceCard/ServiceCard';
import { SectionHeading, SuggestionsCardsWrapper } from '../SearchSuggestions.styles';

type Props = {
    services: ServiceSearchItem[];
    onClick?: ServiceSuggestionClickHandler;
};

const SEARCH_SUGGESTIONS_SERVICES = 'search-suggestions-services';

export const ServicesSuggestions: FC<Props> = ({ services, onClick }) => {
    const { t } = useTranslations();

    return (
        <section data-test={SEARCH_TEST_ID.SUGGESTIONS_SERVICES} aria-labelledby={SEARCH_SUGGESTIONS_SERVICES}>
            <SectionHeading tag="h2" variant="title-100" id={SEARCH_SUGGESTIONS_SERVICES}>
                {t['search.suggestions.services.title']}
            </SectionHeading>
            <SuggestionsCardsWrapper>
                {services.map((service) => (
                    <ServiceCard
                        key={service.id}
                        variant="minimal"
                        title={service.title}
                        icon={service.icon}
                        description={service.shortDescription}
                        url={getFullUrl(service.url)}
                        onClick={(event) => onClick?.(service, event)}
                    />
                ))}
            </SuggestionsCardsWrapper>
        </section>
    );
};
